const P: Record<string, string> = {
  stay: 'M3 10.6 12 3.6l9 7v9.2a1.2 1.2 0 0 1-1.2 1.2H4.2A1.2 1.2 0 0 1 3 20.8z M9.4 21.8v-6.2h5.2v6.2',
  travel: 'M5 16.5h14M4.6 16.5v-4l1.9-4.6a1.4 1.4 0 0 1 1.3-.9h8.4a1.4 1.4 0 0 1 1.3.9l1.9 4.6v4M4.6 12.5h14.8',
  food: 'M7 3v8.2a2.2 2.2 0 0 0 4.4 0V3M9.2 11.4V21M16.6 3c-1.3 1-2 2.6-2 4.6 0 1.8.7 2.9 2 3.3V21',
  groceries: 'M3.6 8.4h16.8l-1.6 10.1a1.5 1.5 0 0 1-1.5 1.3H6.7a1.5 1.5 0 0 1-1.5-1.3zM8.4 8.4 10.6 4m5 4.4L13.4 4M9.6 12.4v3.6m4.8-3.6v3.6',
  activity: 'M3.8 9.2V6.8a1.2 1.2 0 0 1 1.2-1.2h14a1.2 1.2 0 0 1 1.2 1.2v2.4a2.4 2.4 0 0 0 0 4.8v2.4a1.2 1.2 0 0 1-1.2 1.2H5a1.2 1.2 0 0 1-1.2-1.2v-2.4a2.4 2.4 0 0 0 0-4.8zM14 6.4v1.8m0 3v1.8m0 3v1.8',
  drinks: 'M5.4 4.2h13.2l-1.3 4.2a5.8 5.8 0 0 1-5.3 4 5.8 5.8 0 0 1-5.3-4zM12 12.4V20M8.2 20h7.6',
  shopping: 'M5.4 8h13.2l1 12H4.4zM8.8 8V6.2a3.2 3.2 0 0 1 6.4 0V8',
  other: 'M12 7.8v4.6l3 1.7',
  settle: 'M4 8.6h13M13.4 5 17 8.6l-3.6 3.6M20 15.4H7m3.6-3.6L7 15.4l3.6 3.6',
  back: 'M14.5 5.5 8 12l6.5 6.5',
  close: 'M6 6l12 12M18 6 6 18',
  plus: 'M12 5v14M5 12h14',
  check: 'M4.8 12.4 9.6 17.2 19.2 7',
  camera: 'M3.6 8.6h3.1l1.5-2.4h7.6l1.5 2.4h3.1v10.2H3.6z',
  info: 'M12 11v5.2M12 7.7v.2',
  export: 'M12 15.2V3.8M8.2 7.6 12 3.8l3.8 3.8M4.6 13.6v4.8a1.4 1.4 0 0 0 1.4 1.4h12a1.4 1.4 0 0 0 1.4-1.4v-4.8',
  ai: 'M12 3.6l1.9 4.5 4.5 1.9-4.5 1.9L12 16.4l-1.9-4.5-4.5-1.9 4.5-1.9zM18.4 15.2l.8 1.9 1.9.8-1.9.8-.8 1.9-.8-1.9-1.9-.8 1.9-.8z',
  sheet: 'M3.6 4.4h16.8v15.2H3.6zM3.6 9.4h16.8M3.6 14.6h16.8M9.2 9.4v10.2M14.8 9.4v10.2',
  printer: 'M7 9.2V3.8h10v5.4M7 18.4H5.2A1.4 1.4 0 0 1 3.8 17v-4.8a1.4 1.4 0 0 1 1.4-1.4h13.6a1.4 1.4 0 0 1 1.4 1.4V17a1.4 1.4 0 0 1-1.4 1.4H17M7 14.8h10v5.4H7z',
  link: 'M10.2 13.8a3.6 3.6 0 0 0 5.2 0l2.8-2.8a3.7 3.7 0 0 0-5.2-5.2l-1.2 1.2M13.8 10.2a3.6 3.6 0 0 0-5.2 0l-2.8 2.8a3.7 3.7 0 0 0 5.2 5.2l1.2-1.2',
  trips: 'M4.5 8.5h15v11a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1zM8.8 8.5V6a1.4 1.4 0 0 1 1.4-1.4h3.6A1.4 1.4 0 0 1 15.2 6v2.5M4.5 13h15',
  activityFeed: 'M3.5 12.4h4l2.2-6 3.4 12 2.3-6h5.1',
  you: 'M5 20.2a7.2 7.2 0 0 1 14 0',
  households: 'M4 20V9.6l5-3.8 5 3.8V20M14 20V12l3.5-2.6L21 12v8M6.6 20v-4.2h4.8V20',
  trash: 'M4.8 6.8h14.4M9.4 6.8V4.6h5.2v2.2M6.8 6.8 7.6 20h8.8l.8-13.2M10.4 10.6v5.6m3.2-5.6v5.6',
  chevron: 'M9.4 5.6 15.8 12l-6.4 6.4',
  wallet: 'M3.8 8.2a1.4 1.4 0 0 1 1.4-1.4h12.4a1.4 1.4 0 0 1 1.4 1.4v9.6a1.4 1.4 0 0 1-1.4 1.4H5.2a1.4 1.4 0 0 1-1.4-1.4zM15.4 12.2h3.6v3.2h-3.6z',
  share: 'M8.6 13.4 15.4 17M15.4 7 8.6 10.6M18 7a2.4 2.4 0 1 0-4.8 0 2.4 2.4 0 0 0 4.8 0zM8.4 12a2.4 2.4 0 1 0-4.8 0 2.4 2.4 0 0 0 4.8 0zM18 18.2a2.4 2.4 0 1 0-4.8 0 2.4 2.4 0 0 0 4.8 0z'
};

const CIRCLED = new Set(['other', 'info']);

export type IconName = keyof typeof P | string;

export function Icon({ name, className }: { name: IconName; className?: string }) {
  const d = P[name] || P.other;
  // width/height keep an icon from expanding to fill its parent wherever a CSS
  // rule doesn't size it; any CSS width/height still wins.
  return (
    <svg className={className} viewBox="0 0 24 24" width="20" height="20" fill="none"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true">
      {(CIRCLED.has(name) || !P[name]) && <circle cx="12" cy="12" r="8.6" />}
      {name === 'camera' && <circle cx="12" cy="13.4" r="3.4" />}
      {name === 'travel' && <><circle cx="7.8" cy="16.6" r="1.5" /><circle cx="16.2" cy="16.6" r="1.5" /></>}
      {name === 'you' && <circle cx="12" cy="8.4" r="3.6" />}
      <path d={d} />
    </svg>
  );
}

export function GoogleMark() {
  return (
    <svg viewBox="0 0 48 48" width="19" height="19" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.6 30.2.5 24 .5 14.6.5 6.5 5.9 2.6 13.7l7.8 6.1C12.3 13.9 17.7 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.1 24.5c0-1.6-.1-3.2-.4-4.7H24v9h12.4c-.5 2.9-2.2 5.4-4.6 7l7.6 5.9c4.4-4.1 6.7-10.2 6.7-17.2z" />
      <path fill="#FBBC05" d="M10.4 28.2a14.6 14.6 0 0 1 0-8.4l-7.8-6.1a23.5 23.5 0 0 0 0 20.6l7.8-6.1z" />
      <path fill="#34A853" d="M24 47.5c6.2 0 11.5-2 15.4-5.6l-7.6-5.9c-2.1 1.4-4.8 2.3-7.8 2.3-6.3 0-11.7-4.4-13.6-10.3l-7.8 6.1C6.5 42.1 14.6 47.5 24 47.5z" />
    </svg>
  );
}

export const CATEGORIES = [
  { id: 'stay', label: 'Stay' },
  { id: 'food', label: 'Food' },
  { id: 'groceries', label: 'Groceries' },
  { id: 'travel', label: 'Travel' },
  { id: 'activity', label: 'Activity' },
  { id: 'drinks', label: 'Drinks' },
  { id: 'shopping', label: 'Shopping' },
  { id: 'other', label: 'Other' }
];
